module.exports = __webpack_public_path__ + "static/media/ealamy.6c29ab45.svg";